import React, { useEffect, useState } from 'react'
import jwtDecode from 'jwt-decode'
import { Link } from 'react-router-dom'
import DataTable from "react-data-table-component";
import TableStyles from "react-data-table-component";

import user_Store from '../store/user_store'
import supervisor_Store from '../store/supervisor_store'
import { Button, ButtonGroup, DropdownButton, Dropdown, SplitButton } from 'react-bootstrap'
import ExportCSV from '../functions/ExportCSV';
import Selector_Component from '../component/Selector_Component';
import admin_Store from '../store/admin_store';
import student_Store from '../store/student_store';
import CurrUser from '../functions/UserAuth';
function Supervisor_Page() {

  // Student Store
  const student = student_Store((state) => state.student)
  // Supervisor Store
  const supervisor = supervisor_Store((state) => state.supervisor)
  // Admin Store
  const admin = admin_Store((state) => state.admin)


  const supervisors = supervisor_Store((state) => state.supervisors)
  const getsupervisors = supervisor_Store((state) => state.getsupervisors)
  const putsupervisor = supervisor_Store((state) => state.putsupervisor)
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const currentUser = CurrUser(student, supervisor, admin)
  //  let [selectValue, setSelectValue]= useState([])
  function onSelect(actionId, id, setStatus, setClasss) {
    setStatus(actionId)
    let classvalue = actionId == 'Activated' ? 'success' : actionId == 'Deactivated' ? 'danger' : 'warning'
    setClasss(classvalue)
    putsupervisor({ status: actionId }, id)
    //   setClasss(classvalue)
  }

  const columns = [
    {
      name: "ID",
      selector: (row,index) => (index+1),
      sortable: true,
      width: '100px',
      id: 1,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      id: 2,
    },
    {
      name: "name",
      selector: (row) => row.name,
      id: 3,
    },
    {
      name: "location",
      selector: (row) => row.location,
      id: 4,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      id: 5,
    },
    {
      name: "Status",
      cell: (row) => {
        let classs = row.status == 'Pending' ? 'warning' : row.status == 'Activated' ? 'success' : 'danger';
        const status = row.status
        return <Selector_Component classs={classs} row={row} onSelect={onSelect} status={status} />
      }
      ,
      ignoreRowClick: true,
      allowOverflow: true,

      // button: true,
    },

  ];
  let [mydata, setMydata] = useState([])

  useEffect(() => {
    getsupervisors(currentUser?.token)
  }, [])

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };

  const handlePageChange = (page) => {
    setPage(page);
  };
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);


  function onChange(e) {
    let word = e.target.value
    const result = supervisors.data.filter(supervisor => supervisor.name && supervisor.name.toLowerCase().includes(word.toLowerCase()) || supervisor.email.includes(word) || supervisor?.id == word)
    setMydata(result)

    if (word === '') {
      setMydata([])
      setResetPaginationToggle(!resetPaginationToggle);
    }
  }

  function exportTable() {
    let arr = mydata.length > 0 ? mydata : supervisors.data
    arr.forEach((obj,index) => obj.id=index+1)
    arr.forEach((obj) => obj.created_at= (new Date(obj?.created_at ?? '')?.toLocaleString()?.replace(',', '-') ?? '') )
    arr.forEach((obj) => delete obj.image)
    arr.forEach((obj) => delete obj.roles)
    arr.forEach((obj) => delete obj.student)
    ExportCSV(arr,'supervisors')

  }

  return (
    <>
      <div className='d-flex bd-highlight'>
        <div className='pt-2 flex-grow-1 bd-highlight'>
          <input
            type='text'
            onChange={(e) => onChange(e)}
            className='form-control w-50'
            placeholder='Search..'
            required
            aria-label=''
            aria-describedby='basic-addon1'
          />
        </div>
       
        <div className='p-2 bd-highlight'>
          <button
            onClick={function () {
              exportTable()
            }}
            className='btn   btn-md btn btn-outline-primary'
            type='button'
          >
            CSV
          </button>
        </div>
      </div>

      <DataTable
        title="Supervisors"
        columns={columns}
        data={mydata?.length > 0 ? mydata : supervisors.data}
        progressPending={false}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={mydata?.length > 0 ? mydata?.length : supervisors?.data?.length}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />
    </>
  );
};

export default Supervisor_Page
